<template>
  <div v-if="showBarStatus">
    <div class="notifications-bar" :class="content.class" v-for="notification in notifications" v-bind:key="notification.id" v-bind:id="notification.id">
        <img alt="" class="inline-block notifications-icon" :src="content.icon" />

        <span>
        {{ content.message }} <span><a href="https://speakol.zendesk.com/hc/en-us/articles/360016704060-Bidding-Strategy" target="_blank" rel="noopener noreferrer">Learn more</a></span>
        </span>

        <span class="dismiss-notification">
        <vs-icon
            class="dismiss-icon"
            icon="speakol-cancel"
            icon-pack="speakol"
            v-on:click="
            dismissNotification(
                { href_type: 'dismiss', title: 'dismiss' },
                notification.id
            )
            "
        />
        </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notifications: {
      required: true
    }
  },
  data () {
    return {
      hideBarStatus: false
    }
  },
  computed: {
    content () {
      if (!this.notifications) {
        return null
      }

      return {
        class: 'info',
        message: this.$t('alternative_cpc_note'),
        icon: require('@/assets/images/status-bar/info.svg')
      }
    },
    showBarStatus () {
      if (!this.notifications || this.hideBarStatus) {
        return false
      }

      return true
    }
  },
  methods: {
    async dismissNotification (cta, notification_id) {
      this.$gtag.event(`Notification-Actions-'${cta.title}`)

      await window.axios.post('/notifications-center/event', {
        notifications_ids: [notification_id],
        event_name: cta.title,
        hideLoader: true
      })

      this.hideBarStatus = true
    }
  }
}
</script>

<style lang="scss" scoped>
.notifications-bar {
  color: rgba(0, 0, 0, 0.65);
  border-radius: 0.5rem;
  text-align: left;
  padding: 15px 20px;
  margin-bottom: 30px;
}

.dismiss-notification {
  float: right;

  .dismiss-icon {
    color: var(--graniteGray);
    font-size: 14px !important;
    cursor: pointer;
    margin-right: 0;
  }
}

.info {
  border: 1px solid #0092d7;
  background-color: #e6f7ff;
}

.warning {
  border: 1px solid #f2af03;
  background-color: #f9f4e7;
}

.danger {
  border: 1px solid #ffa39e;
  background-color: #fff1f0;
}

.success {
  border: 1px solid #21ba45;
  background-color: #eefaf0;
}

.notifications-icon {
  position: relative;
  top: 5px;
  margin-right: 12px;
}
</style>
